function required(name: string): string {
  const v = import.meta.env[name] as string | undefined;
  if (!v) throw new Error(`${name} is not set (see .env.example)`);
  return v;
}

/**
 * A local build names the API as localhost. A phone that opened the page by the laptop's LAN name (through the
 * dev loop's https front door, scripts/lan-proxy.mjs) reaches the API on the same origin under /api.
 */
function lanAware(url: string): string {
  try {
    const u = new URL(url);
    const page = window.location.hostname;
    const local = page === "localhost" || page === "127.0.0.1" || page.endsWith(".localhost");
    if ((u.hostname === "localhost" || u.hostname === "127.0.0.1") && !local) return `${window.location.origin}/api`;
  } catch {
    /* keep as given */
  }
  return url;
}

export const env = {
  auth0Domain: required("VITE_AUTH0_DOMAIN"),
  auth0ClientId: required("VITE_AUTH0_CLIENT_ID"),
  auth0Audience: required("VITE_AUTH0_AUDIENCE").replace(/\/+$/, ""),
  apiUrl: lanAware(required("VITE_PACS_API_URL").replace(/\/+$/, "")),
  // The bare domain (e.g. pacs.moyae-dev.com, or localhost locally) shows the landing page; {tenant}.<base> is a
  // practice's app. Unset = the app on every host (until per-tenant hosts are live).
  baseDomain: (import.meta.env.VITE_PACS_BASE_DOMAIN as string | undefined)?.toLowerCase(),
};

/** The practice (tenant code) this host belongs to, "" for the bare domain, null when hosts are not split. */
export function tenantFromHost(hostname = window.location.hostname): string | "" | null {
  const base = env.baseDomain;
  if (!base) return null;
  const h = hostname.toLowerCase();
  if (h === base) return "";
  if (h.endsWith(`.${base}`)) {
    const sub = h.slice(0, -(base.length + 1));
    return /^[a-z0-9-]{2,32}$/.test(sub) ? sub : "";
  }
  return "";
}
